import { FILE_TYPE } from "../constants/file-image-types";

const MIMES_MAP = {
    [FILE_TYPE.PSD]: 'image/vnd.adobe.photoshop',
    [FILE_TYPE.MOV]: 'video/quicktime',
    [FILE_TYPE.PSB]: 'image/vnd.adobe.photoshop',
    [FILE_TYPE.OTF]: 'application/vnd.oasis.opendocument.formula-template',
    [FILE_TYPE.FIGMA]: 'application/x-xfig',
    [FILE_TYPE.IDML]: 'application/vnd.adobe.indesign-idml-package',
}

export const readImageDimensions = (file) => new Promise((resolve) => {
  if (!file.type || !file.type.startsWith('image/') || file.type.includes('photoshop')) {
    resolve(null);
    return;
  }

  const url = URL.createObjectURL(file);
  const image = new Image();
  image.onload = () => {
    const width = image.naturalWidth;
    const height = image.naturalHeight;
    URL.revokeObjectURL(url);
    resolve(width > 0 && height > 0 ? { width, height } : null);
  };
  image.onerror = () => {
    URL.revokeObjectURL(url);
    resolve(null);
  };
  image.src = url;
});

export const getMimeType = file => {
  if (file.type) {
    return file.type;
  }

  const parts = file.name.split('.');
  const extension = parts[parts.length - 1];

  return MIMES_MAP[extension.toLowerCase()];
}
